/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/comps/InputNumber.tsx
 * @Description:
 */
import { InputNumber } from 'antd';
import { numberAdd, numberMinus, numberMutiply, numberDivide } from 'libs/compute';
import { cls } from 'reactutils';
interface InputNumberProps {
  disabled?: boolean;
  value?: number;
  min?: number;
  max?: number;
  step?: number;
  onChange?: Function;
  floatSize?: number;
}
const InputNumberComp = ({
  disabled = false,
  value = 0,
  min = 0.0001,
  max = 99999999,
  step = 1,
  onChange,
}: InputNumberProps) => {
  return (
    <>
      <InputNumber
        addonBefore={
          <a
            className={cls(
              'input-number__btn input-number__minus J_NumberMinus',
              (value <= min || disabled) && 'disabled',
            )}
            onClick={() => {
              if (parseFloat(numberMinus(value, 1)) < min) {
                onChange(1);
                return;
              }
              onChange(parseFloat(numberMinus(value, 1)));
            }}
          >
            -
          </a>
        }
        addonAfter={
          <a
            className={cls(
              'input-number__btn input-number__plus J_NumberPlus',
              (value >= max || disabled) && 'disabled',
            )}
            onClick={() => {
              if (parseFloat(numberAdd(value, 1)) > max) {
                onChange(max);
                return;
              }
              onChange(parseFloat(numberAdd(value, 1)));
            }}
          >
            +
          </a>
        }
        controls={false}
        min={min}
        max={max}
        disabled={disabled}
        step={1}
        value={value}
        onChange={(v) => {
          if (v === null) {
            onChange(v);
            return;
          }
          onChange(
            parseFloat(numberDivide(Math.trunc(parseFloat(numberMutiply(v, 10000))), 10000)),
          );
        }}
        onBlur={() => {
          if (value === null) {
            onChange(step);
            return;
          }
        }}
      />
      <style jsx>{`
        :global(.ant-input-number-group-addon) {
            width: 28px;
            line-height: 26px;
            padding: 0;
            border: 1px solid #e8e8e8;
            background-color: #fff;
        }
        :global(.ant-input-number-input) {
            height: 26px;
            line-height: 24px;
            text-align: center;
            outline: none;
            font-size: 12px;
        }
        :global(.ant-input-number) {
            border: 1px solid #e8e8e8;
            box-shadow: none;
        }
        :global(.ant-input-number:hover) {
            border-color: #e8e8e8;
        }
        .input-number__btn {
            display: inline-block;
            line-height: 24px;
            color: #999;
            font-size: 16px;
            font-weight: 700;
            text-align: center;
            width: 100%;
            height: 100%;
        }
        .input-number__btn:hover {
            color: var(--rv-primary-color);
            text-decoration: none;
        }
        .input-number__btn.disabled {
            color: #c8c8c8;
            cursor: not-allowed;
            pointer-events: none;
        }
    `}</style>
    </>
  );
};
export default InputNumberComp;
